import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Spinner, Modal, Dropdown, Card } from 'react-bootstrap';
import appUrl from '../../appUrl';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Table.css';
import { FaEye } from "react-icons/fa";
import { FaTrashCan } from "react-icons/fa6";
import { Link } from 'react-router-dom';
// import { GrDocumentPdf } from "react-icons/gr";
// import ImageCarousel from '../Carousel';
// import { MdEdit } from "react-icons/md";

const BusinessTable = ({ status }) => {
    const AppUrl = appUrl();
    const navigate = useNavigate();

    const [fetched, setFetched] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const handleGetAllReports = async () => {
        if(dataLoading) return;
        setDataLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(`${AppUrl}/business/${status}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            if (data.status === true) {
                setFetched(data.data);
                setProjects(data.data);
                setTotalCount(data.data.length);
                setDataLoading(false);
            } else {
                toast.error("Failed to fetch data");
                setDataLoading(false);
            }
        } catch (error) {
            console.log("Error fetching reports:", error);
            toast.error("Error fetching reports");
            setDataLoading(false);
        }
    };

    useEffect(() => {
        setProjects([])
        handleGetAllReports();
    }, [status]);

    const handlePageChange = (page, sizePerPage) => {
        setCurrentPage(page);
        setPageSize(sizePerPage);
    };

    const handleShowModal = (contentType, content, row) => {
        // if (contentType === "Documents" && Array.isArray(content)) {
        //     const documentIcons = content.map((docUrl, index) => {
        //         const fileName = docUrl.split('/').pop(); // Extract the file name from URL

        //         return (
        //             <div key={index} style={{ textAlign: 'center', margin: '10px' }}>
        //                 <a href={docUrl} target="_blank" rel="noopener noreferrer">
        //                     <GrDocumentPdf className='pdf-svg mb-2' />
        //                 </a>
        //                 <p className='file-name'>{fileName}</p>
        //             </div>
        //         );
        //     });

        //     setModalContent({ type: contentType, content: documentIcons });
        // }
        if(contentType === 'Change Status' && content) {
            setModalContent({ type: contentType, content, id: row._id })
        }  else {
            setModalContent({ type: contentType, content });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalContent(null);
    };

    const AccountActionFormatter = (cell, row, id, column) => {
        if (column === 'plan' && row.plan) {
            return row.plan.length > 0 ? (
                <div className='px-2'>
                    <Button size='sm' className='view-button'
                        onClick={() => handleShowModal('Plans', row.plan)}>
                        View Plan
                    </Button>
                </div>
            ) : <p>-</p>;
        }

        return <p>-</p>;
    };

    const handleStatusChange = async (e, id, status) => {
        if(dataLoading) return;
        e.preventDefault();
        const token = localStorage.getItem("token");
        try {
            setDataLoading(true)
            const response = await fetch(`${AppUrl}/business/${id}/status`, {
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ status }),
            });

            const data = await response.json();

            if (response.ok) {
                toast.success("Status updated successfully");
               
                setFetched((prev) =>
                    prev.map((business) =>
                        business._id === id ? { ...business, is_verified: status } : business
                    )
                );
                handleGetAllReports();
            } else {
                toast.error(data.message || "Failed to update status");
            }
        } catch (error) {
            console.log("Error updating status:", error);
            toast.error("Error updating status");
        } finally {
            setDataLoading(false);
            handleCloseModal();
        }
    };

    const handleDeleteBusiness = async (e, id) => {
        e.preventDefault();
        try {
            setDataLoading(true);

            const token = localStorage.getItem('token')

            const res = await fetch(`${AppUrl}/business/${id}/delete`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const data = await res.json();
            if(data.status){
                toast.success("Business deleted successfully");
            } else {
                toast.error(data.message || "Failed to delete business");
            }
        } catch (error) {
            console.error(error)
        } finally {
            setDataLoading(false);
            handleCloseModal();
        }
    };

    const columns = [
        {
            formatter: (cell, row, rowIndex) => pageSize * (currentPage - 1) + rowIndex + 1,
            dataField: 'index',
            text: 'No.',
        },
        {
            dataField: 'email',
            text: 'Email',
            filter: textFilter({ placeholder: 'Search' }),
            formatter: (cell) => {
                return cell ? <div className='flex justify-content-start align-items-center'>
                            {cell}
                       </div> : <p>-</p>
            }
        },
        {
            dataField: 'business_name',
            text: 'Business',
            filter: textFilter({ placeholder: 'Search' }),
            formatter: (cell) => {
                return cell ? <div className='flex justify-content-start align-items-center'>
                            {cell}
                       </div> : <p>-</p>
            }
        },
        {
            dataField: 'plan',
            text: 'Plan',
            formatter: (cell, row) => AccountActionFormatter(cell, row, row._id, 'plan'),
        },
        {
            text: 'View',
            formatter: (cell, row) => {
                return (
                    <div className='flex-center gap-1'>
                        <div className='' onClick={() => navigate(`/home/bookings/${row.business_name}/${row._id}`)}>
                            <Button  size='sm' className='view-details-button-lg py-2'>
                                Bookings
                            </Button>
                        </div>
                        <div className='' onClick={() => navigate(`/home/reviews/${row.business_name}/${row._id}`)}>
                            <Button  size='sm' className='view-details-button-lg py-2'>
                                Reviews
                            </Button>
                        </div>
                    </div>
                );
            }
        },
        {
            dataField: 'status',
            text: 'Status',
            formatter: (cell, row) => (
                <Dropdown onSelect={(status) => handleShowModal('Change Status', status, row)}>
                    <Dropdown.Toggle
                        variant={cell === "approved" ? "success" : cell === "rejected" ? "danger" : "warning"}
                        id="dropdown-basic"
                    >
                        {cell === "approved" ? "Approved" : cell === "rejected" ? "Rejected" : "Pending"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {cell === "approved" ? (
                            <Dropdown.Item eventKey="rejected">Reject</Dropdown.Item>
                        ) : cell === 'pending' ? (
                            <>
                                <Dropdown.Item eventKey="approved">Approve</Dropdown.Item>
                                <Dropdown.Item eventKey="rejected">Reject</Dropdown.Item>
                            </>
                        ) : <Dropdown.Item eventKey="approved">Approve</Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
            ),
        },
        // {
        //     text: 'Action',
        //     formatter: (cell, row) => {
        //         return (
        //             <div className='px-2'>
        //                 <Button variant='danger' size='sm' className='delete-button-lg'>
        //                     Delete
        //                 </Button>
        //             </div>
        //         );
        //     }
        // },
        {
            text: 'Actions',
            formatter: (cell, row) => (
                <div className='flex-center' >
                    <Link className='user-crud-icon' to={{
                            pathname: "/home/view/business",
                            search: `?id=${row._id}`,
                    }}>
                        <span className=''>
                                <FaEye/>
                        </span>
                    </Link>
                    {/* <span className='user-crud-icon'>
                        <MdEdit/>
                    </span> */}
                    <span onClick={() => handleShowModal('Delete Business', row)} className='user-crud-icon' style={{ color: 'red' }}>
                        <FaTrashCan/>
                    </span>
                </div> 
            )
        }
    ];

    return (
        <>
            <ToastContainer />

            {dataLoading ? (
                <div className='loading-spinner'>
                    <Spinner animation="border" role="status" />
                </div>
            ) : (
                <BootstrapTable
                    bootstrap4
                    keyField="_id"
                    data={projects}
                    columns={columns}
                    filter={filterFactory()}
                    pagination={paginationFactory({
                        page: currentPage,
                        sizePerPage: pageSize,
                        totalSize: totalCount,
                        onPageChange: handlePageChange,
                        sizePerPageRenderer: () => null,
                        showTotal: true,
                        paginationTotalRenderer: (from, to, total) => (
                            <div className="pagination-and-entries">
                                <p className="entries">
                                    Showing {from} to {to} of {total} entries
                                </p>
                            </div>
                        ),
                    })}
                />
            )}

            {/* Modal */}
            <Modal className='business-modal' show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalContent ? modalContent.type : ''}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* {modalContent && modalContent.type === 'Documents' && (
                        <div>
                            <p>{modalContent.content}</p>
                        </div>
                    )}
                    {modalContent && modalContent.type === 'Business images' && (
                        <div className='d-flex align-items-center flex-column h-full'>
                            <ImageCarousel data={modalContent.content}/>
                        </div>
                    )} */}
                    {modalContent && modalContent.type === 'Delete Business' && (
                        <p>
                           Are you sure, you want to delete <strong>{modalContent.content.business_name + "?"}</strong>
                        </p>
                    )}
                    {modalContent && modalContent.type === 'Change Status' && (
                        <div>
                            <span>Are you sure you want to change status to</span>
                            <span className={`mx-1 font-bold ${modalContent.content === 'rejected' ? 'text-danger' : 'text-success'}`}>
                                {modalContent.content.split('')[0].toUpperCase() + modalContent.content.slice(1)}
                            </span>
                        </div>
                    )}
                    {modalContent && modalContent.type === 'Plans' && (
                        <div className='plan-modal'>
                            {/* Render plan details */}
                            {modalContent.content.map((plan, index) => (
                                <div key={index}>
                                    <Card >
                                        <Card.Body className='d-flex justify-content-around'>
                                            <div style={{width:"50%",textAlign:"center"}}>
                                                <Card.Img src={plan.plan_image} alt='plan_image'/>
                                            </div>
                                            <div style={{width:"50%"}}>
                                                <Card.Title>{plan.plan_name}</Card.Title>
                                                <Card.Text className='plan-price'>
                                                    ${plan.price}
                                                </Card.Text>
                                                <Card.Text className='plan-description'>
                                                    {plan.description}
                                                </Card.Text>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='modal-cancel-btn' variant="secondary" onClick={handleCloseModal}>
                        Cancel
                    </Button>
                    {modalContent?.type === 'Delete Business' && (
                        <Button
                            disabled={dataLoading}
                            className='modal-delete-btn'
                            variant="danger" 
                            onClick={(e) => handleDeleteBusiness(e, modalContent.content._id)}>
                            {dataLoading ? 
                            <div className='flex-center'>
                                <Spinner style={{ width: '25px', height: '25px'}} animation="border" role="status" />
                            </div>
                            : 
                            <span>Delete</span>}
                        </Button>
                    )}
                    {modalContent?.type === 'Change Status' && (
                        <Button
                            disabled={dataLoading}
                            className='modal-edit-btn'
                            onClick={(e) => handleStatusChange(e, modalContent.id, modalContent.content)}>
                            {dataLoading ? 
                            <div className='flex-center'>
                                <Spinner style={{ width: '25px', height: '25px'}} animation="border" role="status" />
                            </div>
                            : 
                            <span>Save Changes</span>}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default BusinessTable;
